import React from 'react'
import {applicationStyles, colors} from 'themes'

export default ({ title }) => (
  <div css={{ width: '100%', backgroundColor: colors.darkBlue, color: colors.white, borderTop: `3px solid ${colors.green}` }}>
    <div 
      css={{
        ...applicationStyles.mainTextContainer,
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: 30,
        paddingBottom: 30,
        marginBottom: 30,
      }}
    >
      <h1>
        {title}
      </h1>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/base/pageTitle.js